import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';

@Component({
  selector: 'fi-undo-assignment-process',
  templateUrl: './undo-assignment-popup.component.html',
  styleUrls: ['./undo-assignment-popup.component.scss'],
  standalone: false,
})
export class UndoAssignmentPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  searchedText = '';
  note = '';
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_FORWARD_UNDO', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_FORWARD_UNDO', true);
  submitting: boolean;
  inValidNote = false;

  constructor(
      public dialogRef: MatDialogRef<UndoAssignmentPopupComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string },
      @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    return !!this.note?.trim() && !!this.leadId && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;
      this.actionDataService.undoAssignment(this.leadId, this.note).subscribe(({success, data}) => {
        if (success) {
          this.clearClassAndCloseDialog(this.dialogRef, 'remove');
        }

        this.submitting = false;
      });
    }
  }
}
